import React, { useEffect, useState, useContext } from "react";

//import helper functions
import { getClusters, getEnterpriseToken } from "./helpers";

//for browser history
import { useHistory } from "react-router-dom";

//global state
import { StateContext, StateDispatchContext } from "../../AppStateContext";

//component imports
import WCSRoutes from "./WCSRoutes";
import WeaviateErrorPage from "../../components/console/WeaviateErrorPage";

//spinner
import Spinner from "../../components/console/Spinner";

// Styling
import "./Styles.scss";

const Module = () => {
  const [clusters, setClusters] = useState(null);

  //to access browser history
  const history = useHistory();

  //access global state
  const state = useContext(StateContext);
  const setState = useContext(StateDispatchContext);

  const access_token = JSON.parse(localStorage.getItem("access_token"));

  useEffect(() => {
    //when the module is first loaded, it makes a request to get the clusters
    //and also the enterprise token in case the user needs to access it
    const access_token = JSON.parse(localStorage.getItem("access_token"));

    if (JSON.parse(localStorage.getItem("access_token")) !== "") {
      setTimeout(() => {
        getClusters(setClusters, state, setState, history);
      }, 1500);

      getEnterpriseToken();
    }

    //disconnects from any cluster if user is not authenticated
    if (access_token === "") {
      setState({ ...state, connectToWeaviateURI: "" });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [access_token]);

  if (clusters) {
    return (
      <div
        className={
          state.theme === "dark"
            ? "__WCSModule __WCSModuleDark"
            : "__WCSModule __WCSModuleLight"
        }
      >
        <WCSRoutes clusters={clusters || null} />
      </div>
    );
  } else if (JSON.parse(localStorage.getItem("hasSharedQuery"))) {
    localStorage.setItem("connectToWeaviateURI", JSON.stringify(""));

    return (
      <WeaviateErrorPage
        text={
          "For safety reasons, sharing a query logs you out of the WCS service. Please log out and log back in to access the WCS module."
        }
      />
    );
  } else {
    return (
      <div className="__WCSModule">
        <Spinner />
      </div>
    );
  }
};

export default Module;
